/* eslint-disable no-empty */
/* eslint-disable jsx-a11y/alt-text */
import { FC } from 'react';

// import { useCookies } from '~/common/hooks/use-cookies';

import { BlinkingImage, SplashLoaderContainer } from './styles';
import { Loader } from '../Loader';
import { CircularGlow } from '../CircularGlow';
import logo from '../../../../public/images/logo-header.png';

export const SplashLoader: FC = () => {
  // const { destroyAll } = useCookies();

  // useEffect(() => {
  //   const timeout = setTimeout(async () => {
  //     destroyAll();

  //     try {
  //       console.log('Clearing local and session storage');
  //       localStorage?.clear();
  //       sessionStorage?.clear();
  //       console.log('Local and session storage cleared');
  //     } catch {
  //       console.error('Error clearing local and session storage');
  //     }

  //     try {
  //       // Limpa Cache API
  //       console.log('Clearing caches');
  //       if ('caches' in window) {
  //         const names = await caches.keys();
  //         await Promise.all(names.map((name) => caches.delete(name)));
  //       }
  //       console.log('Caches cleared');
  //     } catch {
  //       console.error('Error clearing caches');
  //     }

  //     try {
  //       // Desregistra Service Workers
  //       if ('serviceWorker' in navigator) {
  //         console.log('Unregistering service workers');
  //         const registrations =
  //           await navigator.serviceWorker.getRegistrations();
  //         await Promise.all(registrations.map((reg) => reg.unregister()));
  //         console.log('Service workers unregistered');
  //       }
  //     } catch {
  //       console.error('Error unregistering service workers');
  //     }

  //     window.location.reload();
  //   }, 7500);

  //   return () => clearTimeout(timeout);
  // }, [destroyAll]);

  return (
    <SplashLoaderContainer>
      <CircularGlow />
      <BlinkingImage alt="logo" src={logo} objectFit="contain" />
      <Loader size={100} type="bar" color="green.600" />
    </SplashLoaderContainer>
  );
};
